(() => {
  'use strict';

  const normalizeVisualGroup = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const readVariantMatrix = (root) => {
    const script = root.querySelector('[data-topfinel-variant-matrix]');
    if (!script) return [];
    try {
      const variants = JSON.parse(script.textContent || '[]');
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  };

  const resolveDownstreamSelections = (event) => {
    const input = event.target;
    if (!input.matches('input[data-option-name]')) return;
    const root = input.closest('variant-selects');
    if (!root || root.dataset.topfinelVariantResolverBusy === 'true') return;
    const groups = [...root.querySelectorAll('fieldset')];
    const changedIndex = groups.findIndex((group) => group.contains(input));
    const variants = readVariantMatrix(root);
    if (changedIndex < 0 || !variants.length) return;

    root.dataset.topfinelVariantResolverBusy = 'true';
    try {
      const selected = groups.map((group) => group.querySelector('input[data-option-name]:checked')?.value || '');
      for (let index = changedIndex + 1; index < groups.length; index += 1) {
        const candidates = variants.filter((variant) => Array.isArray(variant.options)
          && selected.slice(0, index).every((value, optionIndex) => value && variant.options[optionIndex] === value));
        if (!candidates.length) break;

        const enabledInputs = [...groups[index].querySelectorAll('input[data-option-name]')]
          .filter((candidate) => !candidate.disabled && candidate.getAttribute('aria-disabled') !== 'true');
        const availableValues = new Set(candidates
          .filter((variant) => variant.available === true)
          .map((variant) => variant.options[index]));
        const currentInput = enabledInputs.find((candidate) => candidate.checked);
        const currentValue = currentInput?.value || '';
        const currentRemainsValid = currentInput && availableValues.has(currentValue);
        const nextInput = currentRemainsValid
          ? currentInput
          : enabledInputs.find((candidate) => availableValues.has(candidate.value));

        if (!nextInput) {
          groups[index].querySelectorAll('input[data-option-name]:checked').forEach((checked) => {
            checked.checked = false;
          });
          selected[index] = '';
          break;
        }
        if (!nextInput.checked) nextInput.checked = true;
        selected[index] = nextInput.value;
      }
    } finally {
      root.dataset.topfinelVariantResolverBusy = 'false';
    }
  };

  const initialize = () => {
    document.querySelectorAll('variant-selects').forEach((root) => {
      if (!root.dataset.topfinelVariantResolverBound) {
        root.addEventListener('change', resolveDownstreamSelections, true);
        root.dataset.topfinelVariantResolverBound = 'true';
      }
    });

    document.querySelectorAll('.topfinel-pdp-variant-picker__value--visual').forEach((value) => {
      const input = value.querySelector('input[data-visual-group]');
      if (input) value.dataset.visualGroup = normalizeVisualGroup(input.dataset.visualGroup);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
})();
